export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11381.6b83d805.jpg";